import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { FundsMatching } from './funds.matching.entity';

export class CreateFundsMatchingDto extends Omit(FundsMatching, [...BaseEntityFieldsArray]) {}
